import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { offer } from '../data/offer';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
}
export function CtaButton({
  children,
  size = 'lg',
  className = '',
  href = offer.checkoutUrl
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  const sizing = size === 'lg' ? 'px-8 py-5 text-lg sm:text-xl' : 'px-6 py-3.5 text-base';
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`group inline-flex items-center justify-center gap-3 rounded-md bg-lime font-display font-bold uppercase tracking-wide text-ink transition-[transform,background-color] duration-150 ease-out hover:bg-[#e6ff73] active:translate-y-px ${sizing} ${className}`} data-id="element-13" data-mp="llh0j5opyyq1">
      <span className="text-center leading-tight" data-id="element-14" data-mp="159zwc648dadp">{children}</span>
      <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-15" data-mp="157dg7i39xmjv" />
    </a>;
}